import { FC } from "react"

import { ACTION_BADGE_CONFIG } from "components/risk/constants"

interface Props {
  action: string
}

export const ActionBadge: FC<Props> = ({ action }) => {
  const c = ACTION_BADGE_CONFIG[action] || { label: action, cls: "badge-ghost" }
  return <span className={`badge ${c.cls} badge-sm`}>{c.label}</span>
}
